import React, {useRef, useEffect, useState} from "react";
import Header from "../../components/Header";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import LoginComponent from "../../components/Profile/LoginComponent";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import RegisterComponent from "../../components/Profile/RegisterComponent";

function Login() {
    useEffect(() => {
        document.title = "Geoticket - Login";
    }, []);
    const navigate = useNavigate()
    const [user, setUser] = useState(null);
    useEffect(() => {
        global.permission().then((user) => {
            navigate(`/user/account`);
        }).catch(error => {
        });
    }, [user]);

    let callbackLogin = (user) => {
        setUser(user);
    }

    return (
        <div>
            <Header/>
            <div className="container" style={{paddingTop: 86, minHeight: "100vh"}}>
                <Row>
                    <Col xs={12} md={6} sm={12}>
                        <LoginComponent onLogin={callbackLogin}/>
                    </Col>
                    <Col xs={12} md={6} sm={12}>
                        <RegisterComponent onLogin={callbackLogin}/>
                    </Col>
                </Row>
            </div>
            <Footer/>
        </div>
    );
}

export default Login;